import { Component, OnInit, Output, AfterViewInit, OnDestroy } from '@angular/core';
import { DialogComponent } from '../../dialog.component';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { environment } from '@env';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-popup-confirmation-download',
  templateUrl: './dialog-pdf-confirmation-download.component.html',
  styleUrls: ['./dialog-pdf-confirmation-download.component.scss']
})
export class DialogPdfConfirmationDownload implements OnInit {

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<DialogPdfConfirmationDownload>,
    public dateComponent: DialogComponent,
    protected _sanitizer: DomSanitizer
  ) {
    this.dataComponent = dateComponent.data;
  }

  public reportUrl;
  public loading;
  public env = environment;
  public dataComponent: any;

  ngOnInit() {
    this.reportUrl = this._sanitizer.bypassSecurityTrustResourceUrl(this.dataComponent.data.url);
    (window as any).psClosePopUp = () => {
      this.dialogRef.close();
    };
  }

}
